import 'css-chunksrc/client/scenes/constrainElement/constrainedElement/styles.scss';export default {
  "constrainedElement": "_constrainedElement_1wjpq_1",
  "dateType": "_dateType_1wjpq_14",
  "element": "_element_1wjpq_20",
  "name": "_name_1wjpq_25",
  "date": "_date_1wjpq_14",
  "footer": "_footer_1wjpq_35"
};